import { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../ui/common/sheet";

interface CommonModalProps {
  modalOpenState: boolean;
  modalCloseState: (state: boolean) => void;
  children: ReactNode;
  title?: string;
  size?: "mini" | "tiny" | "small" | "large" | "fullscreen";
  centered?: boolean;
  customModalTitleMain?: string;
  customModalTitle?: string;
  customDimmer?: string;
  style?: React.CSSProperties;
  testId?: string;
  modalDescription?: ReactNode;
  contentClassName?: string;
}

export const CommonModal: React.FC<CommonModalProps> = ({
  modalOpenState,
  modalCloseState,
  children,
  title,
  testId,
  modalDescription,
  contentClassName
}) => {
  return (
    <Sheet open={modalOpenState} onOpenChange={modalCloseState}>
      <SheetContent
        side="right"
        data-testid={testId}
        className={cn("!tw-w-full sm:!tw-max-w-6xl !tw-p-0 tw-flex tw-flex-col", contentClassName)}
      >
        <SheetHeader className="tw-px-6 tw-pt-6 tw-pb-2 tw-border-b tw-border-border tw-shrink-0">
          <SheetTitle className="tw-text-lg tw-font-bold tw-text-foreground">{title}</SheetTitle>
          {modalDescription ? <SheetDescription>{modalDescription}</SheetDescription> : null}
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
};
